export default __webpack_public_path__ + "static/media/logo.a89b625b.svg";